export default {
  title: "Webclient"
};
